import { render, staticRenderFns } from "./talepmalzemeler.vue?vue&type=template&id=4c69a0a4&"
import script from "./talepmalzemeler.vue?vue&type=script&lang=js&"
export * from "./talepmalzemeler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports